module.exports = __webpack_public_path__ + "static/media/logo-banner.92a17bc9.png";